// extracted by mini-css-extract-plugin
module.exports = {"Rating":"Rating_Rating__VD25U","Rating_Text":"Rating_Rating_Text__643Ou","Rating_Wrapper":"Rating_Rating_Wrapper__VhZlm","Rating_legend":"Rating_Rating_legend__h7k3T"};